<template>
    <div class="grid grid-cols-12 gap-5 mt-5 p-5">
        <div class="col-span-12 sm:col-span-4" v-for="data in planList" :key="data">
            <div class="box rounded-md relative zoom-in shadow-lg bg-[#f2f2f2] h-full">
                <div class="header p-3 border-b-1"><span class="font-bold">[{{data.sol_type}}]</span> {{data.sol_des == "อื่นๆ" ? data.sol_des+(data.sol_other?' - '+data.sol_other:'') : data.sol_des}}</div>
                <div class="flex flex-wrap items-center">
                    <div class="font-medium text-center p-3 py-5 box-card">
                        การติดตามการดำเนินการ
                    </div>
                    <div>
                        <span class="coordinate-icon m-auto w-8 h-8 p-2 flex justify-center items-center rounded-full" :class="getThemeColor(data.status)">{{data.activities?.length > 0 ? data.activities.length : 0}}</span>
                    </div>
                </div>
                <hr>
                <div class="flex justify-end items-center p-3 py-2">
                    <button
                        class="btn btn-primary text-xs"
                        href="javascript:;"
                        @click="openAddModal(data)"
                        v-if="getAllowActionByCurrRole('create-problem-plan')"
                        :disabled="data.status == 2 || dataList.prob_summary[route.query.prob][dataList.prob_summary[route.query.prob].findIndex(x => x.code == route.query.code)].status == 3"
                    >
                        เพิ่ม
                    </button>
                    <button
                        class="btn btn-primary text-xs ml-2"
                        href="javascript:;"
                        @click="openViewModal(data)"
                    >
                        แสดง
                    </button>
                    <button
                        class="btn btn-primary text-xs ml-2"
                        @click="closeCase(data)"
                        v-if="getAllowActionByCurrRole('edit-problem-plan')"
                        :disabled="data.status == 2 || data.status == 0 || dataList.prob_summary[route.query.prob][dataList.prob_summary[route.query.prob].findIndex(x => x.code == route.query.code)].status == 3"
                    >
                        ยุติความช่วยเหลือ
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue"
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"


const route = useRoute()
const store = useStore()
const props = defineProps({
    dataList: Object,
    activeTab: String
})
const emits = defineEmits(["openViewModal","openAddModal","closeCase"])
const planList = computed(() => {
  let result = []
  if(props.dataList){
    let prob_idx = props.dataList.prob_summary[route.query.prob].findIndex(x => x.code == route.query.code)
    if(props.dataList.prob_summary[route.query.prob][prob_idx].plans?.length>0){
        let filtered = props.dataList.prob_summary[route.query.prob][prob_idx].plans.filter((item)=> item.plan_duration == props.activeTab)
        result = [...filtered]
    }
  }
  return result
})
const tokenParse = store.getters["userAuth/getTokenParsed"]

const openViewModal = (sol_data) =>{
    emits("openViewModal",sol_data)
}
const openAddModal = (sol_data) =>{
    emits("openAddModal",sol_data)
}
const closeCase = (sol_data) =>{
    emits("closeCase", sol_data)
}
const getThemeColor = (status)=>{
    if(status == 1){
        return 'bg-[#ffe699]'
    }
    else if(status == 2){
        return 'bg-[#79d1a1]'
    }
    else{
        return 'bg-[#bfbfbf]';
    }
}
</script>

<style lang="scss">

.box-card{
    display: flex;
    flex-wrap: wrap;
    column-gap: 3px;
    flex-direction: row;
    row-gap: 3px;
    justify-content: center;
}
#view-tracking-process{
    .modal-body{
        padding: 20px !important;
    }
}

</style>